'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
var $p;
/** @constructor */
function $c_Lpresto_UsersView$$anon$44(outer) {
  this.bO7 = null;
  this.bO5 = null;
  this.bO6 = false;
  this.bO3 = null;
  this.bO4 = false;
  this.bO8 = false;
  this.bO9 = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bO7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_UsersView$$anon$44 as $c_Lpresto_UsersView$$anon$44 };
$p = $c_Lpresto_UsersView$$anon$44.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_UsersView$$anon$44;
/** @constructor */
function $h_Lpresto_UsersView$$anon$44() {
}
export { $h_Lpresto_UsersView$$anon$44 as $h_Lpresto_UsersView$$anon$44 };
$h_Lpresto_UsersView$$anon$44.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bO7;
});
$p.t = (function() {
  if ((!this.bO6)) {
    this.bO5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bO6 = true;
  }
  return this.bO5;
});
$p.ad = (function() {
  if ((!this.bO4)) {
    this.bO3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().p8(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bO4 = true;
  }
  return this.bO3;
});
$p.v = (function() {
  if ((!this.bO9)) {
    this.bO8 = false;
    this.bO9 = true;
  }
  return this.bO8;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_UsersView$$anon$44 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_UsersView$$anon$44, "presto.UsersView$$anon$44", ({
  Vh: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_UsersView$$anon$44 as $d_Lpresto_UsersView$$anon$44 };
//# sourceMappingURL=presto.-Users-View$$anon$44.js.map
